import Vue from 'vue'
import VueRouter from 'vue-router'
import multiguard from 'vue-router-multiguard'

import AccountIndex from '../views/account/Index.vue'
import ClientsIndex from '../views/clients/Index.vue'
import AgendaIndex from '../views/agenda-v2/agenda.vue'
import ReportsIndex from '../views/reports/Index.vue'
import FinancialReportsIndex from '../views/financialReports/Index.vue'
import InvoicesIndex from '../views/invoices/Index.vue'
import ConfigIndex from '../views/config/Index.vue'
import Invoices2Index from '../views/invoices2/Index.vue'
import ExportsIndex from '../views/exports/index.vue'

import authRoutes from './routes/auth'
import userRoutes from './routes/users'

import {auth, isAdmin, isManagerPlus} from './middlewares'

Vue.use(VueRouter)

const routes = [
  ...authRoutes,
  ...userRoutes,
  {
    path: '/account',
    name: 'account.index',
    component: AccountIndex,
    beforeEnter: multiguard([auth])
  },
  {
    path: '/agenda',
    name: 'agenda.index',
    component: AgendaIndex,
    beforeEnter: multiguard([auth])
  },
  {
    path: '/clients',
    name: 'clients.index',
    component: ClientsIndex,
    beforeEnter: multiguard([auth, isManagerPlus])
  },
  {
    path: '/reports',
    name: 'reports.index',
    component: ReportsIndex,
    beforeEnter: multiguard([auth, isAdmin])
  },
  {
    path: '/financialReports',
    name: 'financialReports.index',
    component: FinancialReportsIndex,
    beforeEnter: multiguard([auth, isAdmin])
  },
  {
    path: '/invoices-old',
    name: 'invoices.index',
    component: InvoicesIndex,
    beforeEnter: multiguard([auth, isAdmin])
  },
  {
    path: '/invoices',
    name: 'invoices2.index',
    component: Invoices2Index,
    beforeEnter: multiguard([auth, isAdmin])
  },
  {
    path: '/config',
    name: 'config.index',
    component: ConfigIndex,
    beforeEnter: multiguard([auth, isAdmin])
  },
  {
    path: '/exports',
    name: 'exports.index',
    component: ExportsIndex,
    beforeEnter: multiguard([auth, isAdmin])
  },
  {
    path: '*',
    redirect: {name: 'agenda.index'}
  }
]


let router = new VueRouter({mode: 'history', routes,})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js